export function permissiveFilter(value, query) {
    if (!value) {
        return false;
    }
    value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    query = query.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    return value.includes(query);
}